import React from 'react';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Switch from '@material-ui/core/Switch';

interface Props {
  value: { enabled: boolean };
  onChange: (key: string, value: any) => void;
}

function Onboarding({ value, onChange }: Props) {
  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.onboarding.enabled', e.target.checked);
  };

  return (
    <Card>
      <CardHeader
        title="Onboarding"
        action={
          <Switch
            checked={value.enabled}
            inputProps={{ 'aria-label': 'onboarding switch' }}
            onChange={handleToggle}
          />
        }
        subheader="Show a full screen onboarding experience to new users on first visit that will encourage
            them to complete their profiles."
      />
    </Card>
  );
}

export default Onboarding;
